export default "__VITE_ASSET__BFPUqFXj__"